import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login/Login.vue')
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/Home/Home.vue'),
    meta: { requiresAuth: true } // 添加meta字段表示需要验证token
  },
  {
    path: '/clientele',
    name: 'clientele',
    component: () => import('@/views/Clientele/Clientele.vue'),
    meta: { requiresAuth: true, label: '客户管理' },
    redirect: '/clientele/file',
    children: [
      {
        path: 'add',
        name: 'clienteleAdd',
        meta: { label: '添加' },
        component: () => import('@/views/Clientele/views/ClienteleAdd.vue')
      },
      {
        path: 'edit',
        name: 'clienteleEdit',
        meta: { label: '编辑' },
        component: () => import('@/views/Clientele/views/ClienteleEdit.vue'),
        params: true
      },
      {
        path: 'file',
        name: 'clienteleFile',
        meta: { label: '档案' },
        component: () => import('@/views/Clientele/views/ClienteleFile.vue')
      }
    ]
  },
  {
    path: '/cases',
    name: 'cases',
    component: () => import('@/views/Cases/Cases.vue'),
    meta: { requiresAuth: true, label: '案源管理' },
    redirect: '/cases/report',
    children: [
      {
        path: 'report',
        name: 'casesReport',
        redirect: '/cases/report/table',
        meta: { label: '案源报备' },
        component: () => import('@/views/Cases/views/CasesReport.vue'),
        children: [
          {
            path: 'add',
            name: 'casesReportAdd',
            meta: { label: '添加' },
            component: () => import('@/views/Cases/views/CasesReportAdd.vue')
          },
          {
            path: 'table',
            name: 'casesReportTable',
            meta: { label: '案源报备列表' },
            component: () => import('@/views/Cases/views/CaseReportTable.vue')
          }
        ]
      },
      {
        path: 'pending',
        name: 'casesPending',
        meta: { label: '待审批列表' },
        component: () => import('@/views/Cases/views/CasesPending.vue')
      },
      {
        path: 'take',
        name: 'casesTake',
        meta: { label: '待接案列表' },
        component: () => import('@/views/Cases/views/CasesTake.vue')
      },
      {
        path: 'total',
        name: 'casesTotal',
        meta: { label: '接案总计' },
        component: () => import('@/views/Cases/views/CasesTotal.vue')
      }
    ]
  },
  {
    path: '/ajgl',
    name: 'ajgl',
    component: () => import('@/views/Cases/Cases.vue'),
    meta: { requiresAuth: true, label: '案源管理' },
    redirect: '/ajgl/aglist',
    children: [
      {
        path: 'aglist',
        name: 'aglist',
        meta: { label: '待审批列表' },
        component: () => import('@/views/Cases/views/Caseaglist.vue')
      },
      {
        path: 'total',
        name: 'total',
        meta: { label: '接案总计' },
        component: () => import('@/views/Cases/views/CasesTotal.vue')
      }
    ]
  },
  {
    path: '/casemanagement',
    name: 'casemanagement',
    component: () => import('@/views/CaseManagement/Managemnt.vue'),
    meta: { requiresAuth: true, label: '案件管理' },
    redirect: '/casemanagement/progress',
    children: [
      {
        path: 'progress',
        name: 'progress',
        meta: { label: '诉讼在办' },
        component: () => import('@/views/CaseManagement/progress'),
        redirect: '/casemanagement/progress/beforlitigation',
        children: [
          {
            path: 'beforlitigation',
            name: 'beforlitigation',
            meta: { label: '诉前在办' },
            component: () =>
              import('@/views/CaseManagement/progress/BeforLitigation')
          },
          {
            path: 'lawsuit',
            name: 'lawsuit',
            meta: { label: '诉讼在办' },
            component: () => import('@/views/CaseManagement/progress/Lawsuit')
          },
          {
            path: 'caseanomaly',
            name: 'caseanomaly',
            meta: { label: '异常案件' },
            component: () =>
              import('@/views/CaseManagement/progress/Caseanomaly')
          },
          {
            path: 'carryout',
            name: 'carryout',
            meta: { label: '自动履行期' },
            component: () => import('@/views/CaseManagement/progress/caseload')
          },
          {
            path: 'holdcourt',
            name: 'holdcourt',
            meta: { label: '开庭通知' },
            component: () => import('@/views/CaseManagement/progress/holdcourt')
          }
        ]
      },
      {
        path: 'execute',
        name: 'execute',
        meta: { label: '执行在办' },
        component: () => import('@/views/CaseManagement/execute'),
        redirect: '/casemanagement/execute/prepare',
        children: [
          {
            path: 'prepare',
            name: 'prepare',
            meta: { label: '执行执行准备' },
            component: () => import('@/views/CaseManagement/execute/prepare')
          },
          {
            path: 'progress',
            name: 'progress',
            meta: { label: '执行在办' },
            component: () => import('@/views/CaseManagement/execute/progress')
          },
          {
            path: 'abnormal',
            name: 'abnormal',
            meta: { label: '执行异常' },
            component: () => import('@/views/CaseManagement/execute/abnormal')
          }
         
        ]
      },
      {
        path: 'withdrawcase',
        name: 'withdrawcase',
        meta: { label: '退案列表' },
        component: () => import('@/views/CaseManagement/Withdrawcase')
      }
    ]
  },
  {
    path: '/finance',
    name: 'finance',
    component: () => import('@/views/Finance/Finance.vue'),
    meta: { requiresAuth: true, label: '财务管理' },
    redirect: '/finance/handling',
    children: [
      {
        path: 'handling',
        name: 'financeHandling',
        meta: { label: '办案费用' },
        redirect: '/finance/handling/receivables',
        component: () => import('@/views/Finance/handling'),
        children: [
          {
            path: 'receivables',
            name: 'financeHandlingReceivables',
            meta: { label: '应收监管表' },
            component: () => import('@/views/Finance/handling/receivables')
          },
          {
            path: 'advance',
            name: 'financeHandlingAdvance',
            meta: { label: '办公费用垫付表' },
            component: () => import('@/views/Finance/handling/advance')
          }
        ]
      },
      {
        path: 'everyday',
        name: 'financeEveryday',
        meta: { label: '日常费用' },
        redirect: '/finance/everyday/borrowing',
        component: () => import('@/views/Finance/everyday'),
        children: [
          {
            path: 'borrowing',
            name: 'financeEverydayBorrowing',
            meta: { label: '借/支列表' },
            component: () => import('@/views/Finance/everyday/borrowing'),
            redirect: '/finance/everyday/borrowing/borrow',
            children: [
              {
                path: 'borrow',
                name: 'financeEverydayBorrowingBorrow',
                meta: { label: '借支申请单' },
                component: () =>
                  import('@/views/Finance/everyday/borrowing/borrow')
              },
              {
                path: 'expenditure',
                name: 'financeEverydayBorrowingExpenditure',
                meta: { label: '支出证明单' },
                component: () =>
                  import('@/views/Finance/everyday/borrowing/expenditure')
              }
            ]
          },
          {
            path: 'reimbursement',
            name: 'financeEverydayReimbursement',
            meta: { label: '报销管理' },
            component: () => import('@/views/Finance/everyday/reimbursement')
          },
          {
            path: 'invoice',
            name: 'financeEverydayInvoice',
            meta: { label: '发票管理' },
            component: () => import('@/views/Finance/everyday/invoice')
          }
        ]
      },
      {
        path: 'selfowned',
        name: 'financeSelfowned',
        meta: { label: '自有案件' },
        component: () => import('@/views/Finance/selfowned')
      },
      {
        path: 'proceeds',
        name: 'financeProceeds',
        meta: { label: '结案收款' },
        component: () => import('@/views/Finance/proceeds')
      },
      {
        path: 'file',
        name: 'financeFile',
        meta: { label: '结案归档' },
        component: () => import('@/views/Finance/file')
      },
      {
        path: 'sendback',
        name: 'financeSendback',
        meta: { label: '退案列表' },
        component: () => import('@/views/Finance/sendback')
      }
    ]
  },
  {
    path: '/personnel',
    name: 'personnel',
    component: () => import('@/views/Personnel/Personnel.vue'),
    meta: { requiresAuth: true, label: '人事管理' },
    redirect: '/personnel/jobmanagement',
    children: [
      {
        path: 'jobmanagement',
        name: 'personnelJobmanagement',
        meta: { label: '在职管理' },
        component: () => import('@/views/Personnel/jobmanagement'),
        redirect: '/personnel/jobmanagement/overview',
        children: [
          {
            path: 'overview',
            name: 'personnelJobmanagementOverview',
            meta: { label: '在职总览' },
            component: () => import('@/views/Personnel/jobmanagement/overview')
          },
          {
            path: 'attendance',
            name: 'personnelJobmanagementAttendance',
            meta: { label: '员工出勤动态一览' },
            component: () =>
              import('@/views/Personnel/jobmanagement/attendance')
          },
          {
            path: 'leave',
            name: 'personnelJobmanagementLeave',
            meta: { label: '请假' },
            component: () => import('@/views/Personnel/jobmanagement/leave')
          },
          {
            path: 'salary',
            name: 'personnelJobmanagementSalary',
            meta: { label: '调薪' },
            component: () => import('@/views/Personnel/jobmanagement/salary')
          },
          {
            path: 'position',
            name: 'personnelJobmanagementPosition',
            meta: { label: '调岗' },
            component: () => import('@/views/Personnel/jobmanagement/position')
          },
          {
            path: 'trip',
            name: 'personnelJobmanagementTrip',
            meta: { label: '出差' },
            component: () => import('@/views/Personnel/jobmanagement/trip')
          }
        ]
      },
      {
        path: 'dimissionmanagement',
        name: 'personnelDimissionManagement',
        meta: { label: '离职管理' },
        component: () => import('@/views/Personnel/dimissionmanagement'),
        redirect: '/personnel/dimissionmanagement/dimissionlist',
        children: [
          {
            path: 'dimissionlist',
            name: 'personnelDimissionManagementDimissionList',
            meta: { label: '离职列表' },
            component: () =>
              import('@/views/Personnel/dimissionmanagement/dimissionlist')
          },
          {
            path: 'dimissionapplication',
            name: 'personnelDimissionManagementDimissionApplication',
            meta: { label: '离职申请' },
            component: () =>
              import(
                '@/views/Personnel/dimissionmanagement/dimissionapplication'
              )
          }
        ]
      }
    ]
  },
  {
    path: '/synthesis',
    name: 'synthesis',
    component: () => import('@/views/Synthesis/Synthesis.vue'),
    meta: { requiresAuth: true, label: '综合管理' },
    redirect: '/synthesis/worktask',
    children: [
      {
        path: 'worktask',
        name: 'synthesisWorktask',
        meta: { label: '工作任务' },
        component: () => import('@/views/Synthesis/worktask'),
        redirect: '/synthesis/worktask/assignment',
        children: [
          {
            path: 'assignment',
            name: 'synthesisWorktaskAssignment',
            meta: { label: '任务发布' },
            component: () => import('@/views/Synthesis/worktask/assignment'),
            redirect: '/synthesis/worktask/assignment/detail',
            children: [
              {
                path: 'detail',
                name: 'synthesisWorktaskAssignmentDetail',
                meta: { label: '任务详情' },
                component: () =>
                  import('@/views/Synthesis/worktask/assignment/detail')
              },
              {
                path: 'add',
                name: 'synthesisWorktaskAssignmentAdd',
                meta: { label: '新建任务' },
                component: () =>
                  import('@/views/Synthesis/worktask/assignment/add')
              }
            ]
          },
          {
            path: 'summarylist',
            name: 'synthesisWorktaskSummaryList',
            meta: { label: '日报/总结列表' },
            component: () => import('@/views/Synthesis/worktask/summarylist')
          },
          {
            path: 'summaryfillout',
            name: 'synthesisWorktaskSummaryFillout',
            meta: { label: '日报/总结填写' },
            component: () =>
              import('@/views/Synthesis/worktask/summaryfillout'),
            redirect: '/synthesis/worktask/summaryfillout/daily',
            children: [
              {
                path: 'daily',
                name: 'synthesisWorktaSksummaryFilloutDaily',
                meta: { label: '日报' },
                component: () =>
                  import('@/views/Synthesis/worktask/summaryfillout/daily')
              },
              {
                path: 'summarize',
                name: 'synthesisWorktaSksummaryFilloutSummarize',
                meta: { label: '总结' },
                component: () =>
                  import('@/views/Synthesis/worktask/summaryfillout/summarize')
              }
            ]
          }
        ]
      },
      {
        path: 'form',
        name: 'synthesisForm',
        meta: { label: '表单管理' },
        component: () => import('@/views/Synthesis/form'),
        redirect: '/synthesis/form/datas',
        children: [
          {
            path: 'datas',
            name: 'synthesisFormDatas',
            meta: { label: '合同、文件、资料' },
            component: () => import('@/views/Synthesis/form/datas')
          }
        ]
      },
      {
        path: 'learn',
        name: 'synthesisLearn',
        meta: { label: '学习培训' },
        component: () => import('@/views/Synthesis/learn'),
        redirect: '/synthesis/learn/datas',
        children: [
          {
            path: 'datas',
            name: 'synthesisLearnDatas',
            meta: { label: '学习资料' },
            component: () => import('@/views/Synthesis/learn/datas')
          }
        ]
      },
      {
        path: 'systemdocument',
        name: 'synthesisSystemdocument',
        meta: { label: '制度文件' },
        component: () => import('@/views/Synthesis/systemdocument'),
        redirect: '/synthesis/systemdocument/inform',
        children: [
          {
            path: 'inform',
            name: 'synthesisSystemdocumentInform',
            meta: { label: '律所制度文件、通知' },
            component: () => import('@/views/Synthesis/systemdocument/inform')
          }
        ]
      },
      {
        path: 'punishment',
        name: 'synthesisPunishment',
        meta: { label: '处罚通知' },
        component: () => import('@/views/Synthesis/punishment'),
        redirect: '/synthesis/punishment/list',
        children: [
          {
            path: 'list',
            name: 'synthesisPunishmentList',
            meta: { label: '处罚通知列表' },
            component: () => import('@/views/Synthesis/punishment/list')
          }
        ]
      },
      {
        path: 'evidence',
        name: 'synthesisEvidence',
        meta: { label: '证据领用' },
        component: () => import('@/views/Synthesis/evidence'),
        redirect: '/synthesis/evidence/storage',
        children: [
          {
            path: 'storage',
            name: 'synthesisEvidenceStorage',
            meta: { label: '证据列表' },
            component: () => import('@/views/Synthesis/evidence/storage')
          }
        ]
      },
      {
        path: 'expressage',
        name: 'synthesisExpressage',
        meta: { label: '快递收发' },
        component: () => import('@/views/Synthesis/expressage'),
        redirect: '/synthesis/expressage/list',
        children: [
          {
            path: 'list',
            name: 'synthesisExpressageList',
            meta: { label: '收/发列表' },
            component: () => import('@/views/Synthesis/expressage/list'),
            redirect: '/synthesis/expressage/list/receive',
            children: [
              {
                path: 'receive',
                name: 'synthesisExpressageListReceive',
                meta: { label: '收件列表' },
                component: () =>
                  import('@/views/Synthesis/expressage/list/receive')
              },
              {
                path: 'send',
                name: 'synthesisExpressageListSend',
                meta: { label: '发件列表' },
                component: () =>
                  import('@/views/Synthesis/expressage/list/send')
              }
            ]
          }
        ]
      },
      {
        path: 'property',
        name: 'synthesisProperty',
        meta: { label: '资产管理' },
        component: () => import('@/views/Synthesis/property'),
        redirect: '/synthesis/property/materials',
        children: [
          {
            path: 'materials',
            name: 'synthesisPropertyMaterials',
            meta: { label: '收/发列表' },
            component: () => import('@/views/Synthesis/property/materials'),
            redirect: '/synthesis/property/materials/goods',
            children: [
              {
                path: 'goods',
                name: 'synthesisPropertyMaterialsGoods',
                meta: { label: '物品物资领用登记表' },
                component: () =>
                  import('@/views/Synthesis/property/materials/goods')
              },
              {
                path: 'gift',
                name: 'synthesisPropertyMaterialsGift',
                meta: { label: '礼品领用品领用登记表' },
                component: () =>
                  import('@/views/Synthesis/property/materials/gift')
              },
              {
                path: 'work',
                name: 'synthesisPropertyMaterialsWork',
                meta: { label: '办公用品领用登记表' },
                component: () =>
                  import('@/views/Synthesis/property/materials/work')
              }
            ]
          },
          {
            path: 'soft',
            name: 'synthesisPropertySoft',
            meta: { label: '软装资产' },
            component: () => import('@/views/Synthesis/property/soft')
          },
          {
            path: 'hard',
            name: 'synthesisPropertyHard',
            meta: { label: '硬装资产' },
            component: () => import('@/views/Synthesis/property/hard')
          },
          {
            path: 'wholesale',
            name: 'synthesisPropertyWholesale',
            meta: { label: '大额资产采购' },
            component: () => import('@/views/Synthesis/property/wholesale')
          }
        ]
      },
      {
        path: 'badge',
        name: 'synthesisbadge',
        meta: { label: '证章申领' },
        component: () => import('@/views/Synthesis/badge'),
        redirect: '/synthesis/badge/apply',
        children: [
          {
            path: 'apply',
            name: 'synthesisBadgeApply',
            meta: { label: '证、章申领' },
            component: () => import('@/views/Synthesis/badge/apply')
          }
        ]
      },
      {
        path: 'procedure',
        name: 'synthesisProcedure',
        meta: { label: '手续费用申领' },
        component: () => import('@/views/Synthesis/procedure'),
        redirect: '/synthesis/procedure/recommendation',
        children: [
          {
            path: 'recommendation',
            name: 'synthesisProcedureRecommendation',
            meta: { label: '介绍信领取' },
            component: () =>
              import('@/views/Synthesis/procedure/recommendation'),
            redirect: '/synthesis/procedure/recommendation/civil',
            children: [
              {
                path: 'civil',
                name: 'synthesisProcedureRecommendationCivil',
                meta: { label: '民事介绍信领取登记表' },
                component: () =>
                  import('@/views/Synthesis/procedure/recommendation/civil')
              },
              {
                path: 'penal',
                name: 'synthesisProcedureRecommendationPenal',
                meta: { label: '刑事介绍信领取登记表' },
                component: () =>
                  import('@/views/Synthesis/procedure/recommendation/penal')
              }
            ]
          },
          {
            path: 'missive',
            name: 'synthesisProcedureMissive',
            meta: { label: '公函领取' },
            component: () => import('@/views/Synthesis/procedure/missive'),
            redirect: '/synthesis/procedure/missive/civil',
            children: [
              {
                path: 'civil',
                name: 'synthesisProcedureMissiveCivil',
                meta: { label: '民事介绍信领取登记表' },
                component: () =>
                  import('@/views/Synthesis/procedure/missive/civil')
              },
              {
                path: 'penal',
                name: 'synthesisProcedureMissivePenal',
                meta: { label: '刑事介绍信领取登记表' },
                component: () =>
                  import('@/views/Synthesis/procedure/missive/penal')
              }
            ]
          },
          {
            path: 'selfowned',
            name: 'synthesisProcedureSelfowned',
            meta: { label: '自有业务领款函' },
            component: () => import('@/views/Synthesis/procedure/selfowned')
          }
        ]
      }
    ]
  },
  {
    path: '/realty',
    name: 'realty',
    component: () => import('@/views/Realty/Realty.vue'),
    meta: { requiresAuth: true, label: '房地产建筑企业档案' },
    redirect: '/realty/construction',
    children: [
      {
        path: 'construction',
        name: 'realtyConstruction',
        meta: { label: '管理员账户' },
        component: () => import('@/views/Realty/construction')
      }
    ]
  },
  {
    path: '/selfowned',
    name: 'selfowned',
    component: () => import('@/views/SelfOwned/SelfOwned.vue'),
    meta: { requiresAuth: true, label: '自有案件' },
    redirect: '/selfowned/caselist',
    children: [
      {
        path: 'caselist',
        name: 'selfownedCaselist',
        meta: { label: '案件列表' },
        component: () => import('@/views/SelfOwned/caselist')
      },
      {
        path: 'closing',
        name: 'selfownedClosing',
        meta: { label: '结案归档' },
        component: () => import('@/views/SelfOwned/closing')
      },
    ]
  },
  {
    path: '/system',
    name: 'system',
    component: () => import('@/views/System/System.vue'),
    meta: { requiresAuth: true, label: '权限管理' },
    redirect: '/system/customer',
    children: [
      {
        path: 'admin',
        name: 'systemAdmin',
        meta: { label: '管理员账户' },
        component: () => import('@/views/System/views/SystemAdmin.vue')
      },
      {
        path: 'person',
        name: 'systemPerson',
        meta: { label: '员工账号' },
        component: () => import('@/views/System/views/SystemPerson.vue')
      },
      {
        path: 'customer',
        name: 'systemCustomer',
        meta: { label: '客户账号' },
        component: () => import('@/views/System/views/SystemCustomer.vue')
      },
      {
        path: 'logs',
        name: 'systemLogs',
        meta: { label: '日志列表' },
        component: () => import('@/views/System/views/SystemLogs.vue')
      }
    ]
  }
]

// 创建Vue Router实例
const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 添加全局前置守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  // console.log(to,123123);
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 需要验证token的路由
    if (token) {
      if (to.name === 'clienteleEdit' && from.name === null) {
        next({ name: 'clienteleFile' })
      }
      // 有token，允许导航到目标路由
      next()
    } else {
      // 没有token，重定向到登录页面
      next('/login')
    }
  } else {
    // 不需要验证token的路由，直接允许导航
    next()
  }
})

export default router
